import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getUserProjects } from '../../Redux/actions';
import { useParams } from 'react-router-dom';
import axios from 'axios';

export default function GeoTagging({ client_id }) {
    const dispatch = useDispatch();
    const [geoData, setGeoData] = useState([])
    const [showLoader, setShowLoader] = useState(true)
    const mapRef = useRef(null);
    const markers = useRef([]);

    useEffect(() => {
        fetchData();
    }, [client_id]);

    const fetchData = async () => {
        try {
            const res = await axios.get(`/api/v1/project/get-user-projects/${client_id}`);
            setShowLoader(false);
            if (res?.status === 200) {
                let projects = res.data.data.map((project) => ({
                    title: project.projname.replace('WA-', ''),
                    mapurl: project.mapurl,
                }));

                for (let column of ['lat', 'lng']) {
                    projects = projects.map((project) => ({
                        ...project,
                        [column]: parseFloat(project.mapurl.split(',')[column === 'lat' ? 0 : 1]),
                    }));
                }

                projects = projects.filter(
                    (project) => !isNaN(project.lat) && !isNaN(project.lng)
                );

                setGeoData(
                    projects.map((project) => ({
                        lat: project.lat,
                        lng: project.lng,
                        title: project.title,
                    }))
                );
            }
        } catch (error) {
            setShowLoader(false);
            console.error('Error fetching get-user-projects:', error);
        }
    };

    useEffect(() => {
        if (!geoData || geoData.length === 0) {
            return;
        }
    
        const mapOptions = {
            center: { lat: 22.5937, lng: 78.9629 },
            zoom: 4,
        };
    
        const map = new window.google.maps.Map(mapRef.current, mapOptions);
    
        markers.current.forEach(marker => marker.setMap(null));
        markers.current = [];
    
        const bounds = new window.google.maps.LatLngBounds();
    
        geoData.forEach((location) => {
            const position = { lat: location.lat, lng: location.lng };
    
            const marker = new window.google.maps.Marker({
                position,
                map,
                title: location.title,
            });
    
            markers.current.push(marker);
    
            const infoWindow = new window.google.maps.InfoWindow({
                content: location.title,
            });
    
            marker.addListener('click', () => {
                infoWindow.open(map, marker);
            });
    
            if (client_id) {
                bounds.extend(position);
            }
        });
    
        if (client_id) {
            map.fitBounds(bounds);
        }
    }, [geoData, client_id]);
    
    


    return (
        <div className="main w3-margin-top" >
            {geoData?.length === 0 && !showLoader ? (
                <div className='no-data-msg'>No Projects with location data available</div>
            ) : (
                <div
                    ref={mapRef}
                    style={{ height: '550px', width: '100%' }}
                ></div>
            )}
        </div >
    )
}